module.exports = __webpack_public_path__ + "img/chat_Icon_circle.937013e1.svg";